export const scanDocumentGradient = {
    colors: ['#0C0B0B96', '#0C0B0BFF'],
    locations: [0, 0.8619],
    useAngle: true,
    angle: 180,
};
export const underReviewGradient = {
    colors: ['#962DFF', '#842BDD'],
    locations: [0.1269, 0.8468],
    useAngle: true,
    angle: 113,
};
export const actionRequiredGradient = {
    colors: ['#EB5A94', '#E14986'],
    locations: [0.2275, 0.9318],
    useAngle: true,
    angle: 140,
};
export const waitlistGradient = {
    colors: ['#060427', '#1F1D49'],
    locations: [0, 1],
    useAngle: true,
    angle: 180,
};
export const corporateEventGradientColorMap = {
    SPLIT: 'apricot',
    MERGER: 'peach',
    HOLIDAY: 'yellow',
    DIVIDEND: 'turquoise',
    SYMBOL_CHANGE: 'skyBlue',
    LISTING_CHANGE: 'lime',
    EX_DIVIDEND: 'lightPink',
};
